import React from 'react';
import { List, Datagrid, TextField, TextInput, Filter, FunctionField, usePermissions, ReferenceField } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    sanitizeListRestProps,
} from 'react-admin';


const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        showFilter,
    } = useListContext();
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
        </TopToolbar>
    );
};

export const IntentsList = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <List filters={<IntentsFilter />} {...props} actions={<ListActions />} >
            <Datagrid>
                <FunctionField render={record => {
                    if (record.final_status === 'ok') {
                        return 'Completado';
                    } else if (record.final_status === 'in progress') {
                        return 'En progreso';
                    } else {
                        return 'Cancelado';
                    }
                }} label='Estado' />
                {(permissions.includes("users.list")) ?
                    <ReferenceField source="user" label='Usuario' reference="users" link="show">
                        <FunctionField label="Nombre completo" render={record => `${record.firstname} ${record.lastname}`} link="show" />
                    </ReferenceField>
                    : null}
                <TextField source="transaction_splitted" label='Transacción' />
                <TextField source="non_fintoc_order" label='Orden Flow' />
                <TextField source="fintoc_order" label='Orden Fintoc' />
                <TextField source="createdAt" label="Fecha" />
            </Datagrid>
        </List>
    )
};

const IntentsFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar por usuario" source="q" alwaysOn />
    </Filter>
);
